export const DISPLAY_TOAST = 'toast/DISPLAY_TOAST';
export const REMOVE_TOAST = 'toast/REMOVE_TOAST';

export function createNewToastId() {
    return Math.random().toString(36);
}

export function displayToast(toastId, props) {
    return (dispatch) => {
        dispatch({
            type: DISPLAY_TOAST,
            toastId,
            props
        });
    };
}

export function removeToast(toastId) {
    return (dispatch) => {
        dispatch({
            type: REMOVE_TOAST,
            toastId
        });
    };
}
